import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/self-closing-comp */
import { Box, Copy } from '@honda-canada/design-system-react';
import React from 'react';
import themeStyles from '../styles/LoyaltyOfferFilters.styles';
const RegionAndSortContainer = themeStyles.apply(Box, 'RegionAndSortContainer');
const OfferRegionWrapper = themeStyles.apply(Box, 'OfferRegionWrapper');
const SortByWrapper = themeStyles.apply(Box, 'SortByWrapper');
const RegionAndSort = ({ isLoyaltyFilterVisible = false }) => {
    // TODO: replace with dictionary value
    const text = 'Offer Region';
    const sortBy = 'Sort By';
    return (_jsxs(RegionAndSortContainer, { isLoyaltyFilterVisible: isLoyaltyFilterVisible, children: [_jsxs(OfferRegionWrapper, { children: [_jsx(Copy, { fontFamily: "bold", size: "extraSmall", children: text }), _jsx(Box, { height: "20px", bg: "grey.3" })] }), _jsxs(SortByWrapper, { children: [_jsx(Copy, { fontFamily: "bold", size: "extraSmall", children: sortBy }), _jsx(Box, { height: "32px", bg: "grey.3" })] })] }));
};
export default RegionAndSort;
